import { render, staticRenderFns } from "./SmsRecipientSelect.vue?vue&type=template&id=5c22f437&scoped=true&"
import script from "./SmsRecipientSelect.vue?vue&type=script&lang=js&"
export * from "./SmsRecipientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22f437",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
